import { useEffect } from 'react';
import { getAppGlobals } from '~/components/AppGlobals/utils';
const { VITE_ADNETWORK_PIXELV2_URL } = getAppGlobals();

type Props = {
  pixelId: string;
};

const AdNetworkPixelV2 = ({ pixelId }: Props) => {
  useEffect(() => {
    try {
      if (pixelId) {
        if (document.getElementById('beehiiv-pixel-v2')) {
          return; // Pixel script already loaded
        }
        const script = document.createElement('script');
        script.id = 'beehiiv-pixel-v2';
        script.async = true;
        script.innerHTML = `
      (function(){try{
        !function (f, b, e, h, i, v) {
            if (f.bhpx) return;
            i = f.bhpx = function () {
              i.callMethod ?
                i.callMethod.apply(i, arguments) : i.queue.push(arguments)
            };
            if (!f._bhpx) f._bhpx = i;
            i.push = i; i.loaded = !0; i.version = '1.0';
            i.queue = [];

            // Load the pixel script
            v = b.createElement(e); v.async = !0;
            v.type = 'module';
            v.src = '${VITE_ADNETWORK_PIXELV2_URL}';
            h = b.getElementsByTagName(e)[0];
            h.parentNode.insertBefore(v, h);
          }(window, document, 'script');

          // Initialize the pixel script
          // Replace PIXEL_ID with value from Advertiser Portal
          bhpx('init','${pixelId}', {
            trackClientNavigation: true,
            debug: false
          });

          // Send the initial pageview event
          bhpx('track', 'pageview');
        }catch{/*swallow exception*/}})();

      `;
        document.head.appendChild(script);
      }
    } catch {
      /*swallow exception*/
    }
  }, [pixelId]);

  return null;
};

export default AdNetworkPixelV2;
